import { render, staticRenderFns } from "./ImpressumPage.vue?vue&type=template&id=39dd344f&scoped=true&"
import script from "./ImpressumPage.vue?vue&type=script&lang=js&"
export * from "./ImpressumPage.vue?vue&type=script&lang=js&"
import style0 from "./ImpressumPage.vue?vue&type=style&index=0&id=39dd344f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dd344f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VFlex,VLayout,VMain})
